import { Link, useParams } from "react-router-dom";
import { AppRecordV2, AppTypes, IPermissionItem } from "@lhd/types";
import Button from "@lhd/components/Button";
import { ROUTES } from "@lhd/constants";
import {
  APP_TYPES,
  BACK_NAVIGATE_URL_KEY,
} from "@lhd/components/CloneApp/constants";
import { getCompanyId } from "@lhd/utility";

export interface ButtonToCreateProps {
  appType: AppTypes;
  appId: string;
  permission?: IPermissionItem;
  isEditing?: boolean;
  appRecord?: AppRecordV2;
}

const ButtonToCreate = ({
  appType,
  appId,
  permission,
  isEditing,
  appRecord,
}: ButtonToCreateProps) => {
  const { companyId: companyIdParam } = useParams();
  const companyId = Number(companyIdParam || getCompanyId());

  const getLinkNavigate = () => {
    const params = new URLSearchParams({
      [BACK_NAVIGATE_URL_KEY]: `${location.pathname}${location.search}`,
    });
    const ROUTE_MAP: Partial<
      Record<AppTypes, { route: string; hasCompanyIdParam?: boolean }>
    > = {
      [APP_TYPES.COMPANY_POLICIES]: {
        route: ROUTES.COMPANY_POLICIES,
      },
      [APP_TYPES.FINANCIAL_REPORTS]: {
        route: ROUTES.FINANCIAL_REPORTS,
      },
      [APP_TYPES.BUSINESS_TRIP_REPORTS]: {
        route: ROUTES.BUSINESS_TRIP_REPORTS,
      },
      [APP_TYPES.EMPLOYMENT_CONTRACTS]: {
        route: ROUTES.EMPLOYMENT_CONTRACTS,
        hasCompanyIdParam: true,
      },
      [APP_TYPES.AGREEMENTS]: {
        route: ROUTES.AGREEMENTS,
        hasCompanyIdParam: true,
      },
      [APP_TYPES.ROLE_PERMISSIONS]: {
        route: ROUTES.ROLE_PERMISSIONS,
      },
      [APP_TYPES.LABOR_DOCUMENTS]: {
        route: ROUTES.LABOR_DOCUMENTS,
        hasCompanyIdParam: true,
      },
      [APP_TYPES.BUSINESS_FLOW]: {
        route: ROUTES.BUSINESS_FLOW,
        hasCompanyIdParam: false,
      },
      [APP_TYPES.BUSINESS_MANUALS]: {
        route: ROUTES.BUSINESS_MANUALS,
        hasCompanyIdParam: false,
      },
    };
    const routeConfig = ROUTE_MAP[appType];
    if (routeConfig) {
      const { route, hasCompanyIdParam } = routeConfig;
      return `/${route}/${appId}/${ROUTES.CREATE}${
        hasCompanyIdParam && companyId ? `/${companyId}` : ""
      }?${params}`;
    }
    return "";
  };

  return (
    <Link to={getLinkNavigate()} state={{ appRecord }}>
      <Button
        label={"新規行作成（フォーム）"}
        disabled={!permission?.create || !isEditing}
      />
    </Link>
  );
};

export default ButtonToCreate;
